<template>
  <main
    style="padding-top: 85px; -webkit-box-flex: 1; -ms-flex: 1; flex: 1"
    class="container-fluid"
  >
    <section
      v-if="isSearch !== 'S'"
      class="container search"
      style="padding: 15px 0px 6px 0px"
    >
      <div class="row">
        <div class="offset-1 col-8">
          <form class="form">
            <div class="input-group input-lg">
              <div class="input">
                <input
                  type="text"
                  name="Search"
                  id="Search"
                  class="form-control"
                  v-model="keyword"
                  @keydown.enter="doSearch()"
                  placeholder="輸入姓名、身分證、保單號碼或手機進行搜尋..."
                  alt="ch"
                  style="width: 100%"
                  maxlength="40"
                  @input="checkKeyword"
                />
                <span id="searchclear" v-show="keyword" @click="cleanSearch()"
                  >清除</span
                >
              </div>
              <button
                class="btn btn-primary btn-icon"
                type="submit"
                @click.prevent="doSearch()"
              >
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </form>
        </div>
        <div v-if="isSearch == 'D'" class="col-2 text-center">
          <router-link
            @click.native="clearSearchKeyWord"
            :to="{ name: 'joinFamily' }"
            class="btn btn-default btn-lg w-120 fw-600"
          >
            歸戶查詢
          </router-link>
        </div>
        <div v-if="UserInfo.useOldMV || 
            UserInfo.roleId == 'MAINTENANCE_UNIT' ||
	          UserInfo.roleId == 'BUSINESS_UNIT' ||
	          UserInfo.roleId == 'UHD' ||
	          UserInfo.mainUserId" 
	          class="col-1 text-center">
          <!-- <div
            @click.prevent="panelOpen('toOldSystem')"
            class="btn btn-default btn-lg w-120 fw-600"
          >
            回舊保健
          </div> -->
        </div>
      </div>
    </section>
    <section v-else class="container search" style="padding: 15px 0px 6px 0px">
      <div class="row">
        <div class="offset-1 col-9">
          <form class="form">
            <div class="input-group input-lg">
              <div class="input">
                <input
                  type="text"
                  name="Search"
                  id="Search"
                  class="form-control"
                  v-model="keyword"
                  @keydown.enter="doSearch()"
                  placeholder="輸入姓名、身分證、保單號碼或手機進行搜尋..."
                  alt="ch"
                  maxlength="40"
                  @input="checkKeyword"
                />
                <span id="searchclear" v-show="keyword" @click="cleanSearch()"
                  >清除</span
                >
              </div>
              <button
                class="btn btn-primary btn-icon"
                type="submit"
                @click.prevent="doSearch()"
              >
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
    <div v-if="isSearch == 'D'">
      <h4 class="text-green">戶長列表</h4>
      <h5 class="mt-3 mb-20">請選擇你想做建議的家庭</h5>
      <div class="row" v-if="getAllHouseholderBySalesResult.length != 0">
        <div
          class="col-md-3"
          v-for="(item, i) in getAllHouseholderBySalesResult"
          :key="`group-item-${i}`"
          >
          <div class="card">
            <el-switch
                v-model="item.namecovermask"
                active-color="#5DC46C"
                @change=changeCoverMask(item)
                style="float:right;"
            ></el-switch>
          <div @click="saveUserItems(item)">
            <strong v-if="item.namecovermask" class="link text-underline m-0 font-24">
              {{truncate(item.name, 12)}}
            </strong>
            <strong v-else class="link text-underline m-0 font-24">
              {{item.name |getMaskName}}
            </strong>
            <!-- 20210624 個資遮蔽
            <div class="mt-10">
              <avatar class="mr-2" :gender="Number(item.sex)" :size="20" />
              <span style="vertical-align: text-top">{{ item.birthday ? formatDate(item.birthday) : '--' }}</span>
              <strong class="float-right">{{ (item.age || item.age === 0 ? item.age : '--') + '歲' }}</strong>
            </div> -->
            <div class="d-flex justify-content-end mt-10">
              <avatar
                class="mr-2"
                :gender="Number(item.sex)"
                :size="20"
                :height="20"
              />
              <strong>{{
                (item.age || item.age === 0 ? item.age : "--") + "歲"
              }}</strong>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div
        v-else
        class="text-center d-flex justify-content-center mt-5"
        colspan="6"
      >
        <div
          :class="{ 'h2w3 mt-4 section-loading': custsOfAgntIsLoading }"
        ></div>
        <h3 class="mb-3 pre-formatted">{{ this.remoteDataMessage }}</h3>
      </div>
    </div>
    <div v-else-if="isSearch == 'S'">
      <h4 class="text-green">
        搜尋結果
        <a class="btn btn-default btn-sm m-0 ml-3" @click="cleanSearch"
          >返回戶長列表</a
        >
      </h4>
      <div
        class="row mt-20"
        v-if="getFamilyMemberByconditionResult.length != 0"
      >
        <div
          class="col-md-3"
          v-for="(item, i) in getFamilyMemberByconditionResult"
          :key="`group-item-${i}`"
        >
          <div @click="saveUserItems(item, true)" class="card">
            <h4 class="link text-underline m-0 font-24">
              {{ truncate(item.name, 12) }}
            </h4>
            <!-- 20210624 個資遮蔽
            <div class="mt-10">
              <avatar class="mr-2" :gender="Number(item.sex)" :size="20" />
              <span class="mt-1">{{ formatDate(item.birthday) }}</span>
              <strong class="float-right mt-2">{{ (item.age || item.age === 0 ? item.age : '--') + '歲' }}</strong>
            </div>
            -->
            <div class="d-flex justify-content-end mt-10">
              <avatar
                class="mr-2"
                :gender="Number(item.sex)"
                :size="20"
                :height="20"
              />
              <strong>{{
                (item.age || item.age === 0 ? item.age : "--") + "歲"
              }}</strong>
            </div>
            <div class="mt-10" style="height: 44px; word-break: break-all">
              <span class="font-16">{{
                addFamilyName(item.familynamelist)
              }}</span>
            </div>
            <div class="d-flex justify-content-end" style="margin-top: 10px">
              <strong class="font-16">
                {{
                  `共${
                    item.familynamelist[0] == "(無成員)"
                      ? item.familynamelist.length
                      : item.familynamelist.length + 1
                  }人`
                }}
              </strong>
            </div>
            <!-- <div v-else>
              <span
                class="mr-3 h3"
                v-for="(familyItem,familyIndex) in item.familynamelist"
                :key="familyIndex"
              >{{familyIndex < 3 ? familyItem:''}}</span>
            </div>-->
          </div>
          <!-- <div class="action">
            <a
              role="button"
              class="btn btn-sm btn-default btn-icon my-0"
              @click="selectGroup(item, i)"
            >
              <i class="icon-edit"></i>
            </a>
          </div>-->
        </div>
      </div>
      <div
        v-else
        class="text-center d-flex justify-content-center mt-5"
        colspan="6"
      >
        <div
          :class="{ 'h2w3 mt-4 section-loading': custsOfAgntIsLoading }"
        ></div>
        <h3 class="mb-3 pre-formatted mr-5">{{ this.remoteDataMessage }}</h3>
      </div>
    </div>
    <warning-modal
      :open="warningModalOpen"
      :message="warningData[currentWarningType].message"
      :cancelText="`不繼續使用`"
      @close="warningClose"
      @submit="warningSubmit"
    />
    <mv-to-old-popup
      :open="toOldSystem"
      :closeBtn="true"
      @close="checkFamily(`insurance-check`)"
      @closeBtn="panelClose('toOldSystem')"
    >
      <div
        class="text-red d-flex"
        style="margin-left: 14px; font-size: 24px; font-weight: bold"
        slot="head"
      >
        <div class="align-self-center">
          【照過來】保單健檢舊系統將於過年後下線
        </div>
      </div>
      <div class="text" slot="body">
        <div class="text-red">
          1.「四步驟」學會新保健，新系統操作快速上手教學：
        </div>
        <div>CRM首頁>單位布告欄>新保健簡易操作教學</div>
        <br />
        <div class="text-red">2.完整詳細教學影片：</div>
        <div>國泰學習網>課程>業務人員課程>行銷學院>數位工具>CRM2.0</div>

        <br />
        <div class="text-red">3.相關問題反映路徑－簡覆表：</div>
        <div>
          新件輸入>業務員事務>數位經營工具>保單健檢>新式保健系統操作疑問及回饋
        </div>
      </div>
    </mv-to-old-popup>
  </main>
</template>
        

<script>
import moment from "moment";
import Avatar from "@/desktop/components/Avatar";

import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import WarningModal from "@/desktop/components/WarningModal";
import NewGroup from "@/desktop/components/NewGroup";
import AddGroupModal from "@/desktop/components/AddGroupModal";

import { mapGetters } from "vuex";
import {
  getFamilyMemberBycondition,
  getAllHouseholderBySales,
  getFamilyMemberByCsidNo,
} from "@/service";

import { log } from "util";
import mvToOldPopup from "@/desktop/views/mv/components/mvToOldPopup";

export default {
  name: "newMV",
  mixins: [commonMixin],
  data() {
    return {
      coverMask:true,
      value2:true,
      //判斷頁面與BUTTON
      isSearch: "D",
      //戶長列表
      getAllHouseholderBySalesResult: [],
      //搜尋結果
      getFamilyMemberByconditionResult: [],
      //搜尋條件
      keyword: "",
      currentWarningType: "confirmOK",
      newGroupOpen: false,
      addGroupModalOpen: false,
      addGroupEdit: true,
      warningModalOpen: false,
      oldGroup: null,
      warningData: {
        confirmOK: {
          message: "",
          submit: "confirmOK",
        },
      },
      selectedGroup: { name: "" },
      selectedItem: 0,
      groups: {
        name: "滿期年金",
        edit: false,
      },
      isEdit: false,
      custsOfAgntIsLoading: false,
      custsOfGrpIsLoading: false,
      custsOfMvBackIsLoading: false,
      custsOfAgnt: [],
      grpsOfAgnt: [],
      custsOfGrp: [],
      remoteDataMessage: "資料讀取中，請稍候...",
      //上頁
      prevRoute: "",
      toOldSystem: false,
    };
  },
  components: { Avatar, WarningModal, NewGroup, AddGroupModal, mvToOldPopup },
  computed: {
    ...mapGetters(["CustInfo", "UserInfo"]),
  },
  asyncComputed: {
    async checkMvBackComputed() {
      this.custsOfMvBackIsLoading = true;
      let chkExist = false;
      if (
        (!(this.CustInfo.ID && localStorage.CustID) &&
          !(localStorage.SerNo && this.CustInfo.serNo)) ||
        localStorage.checkMvBack == "false"
      ) {
        this.custsOfMvBackIsLoading = false;
        return chkExist;
      } else {
        await getFamilyMemberByCsidNo(
          this.$store.state.userInfo.id,
          this.CustInfo.ID || this.CustInfo.serNo
        ).then((result) => {
          if (result.header) {
            if (result.data && result.data.length > 0) {
              result.data.forEach((item) => {
                if (
                  item.csidno &&
                  item.familyid &&
                  item.csidno === item.familyid
                ) {
                  this.updateUserItems(item);
                  localStorage.userItems = JSON.stringify(item);
                  // this.$router.push({ name: "relation" });
                  chkExist = true;
                  return chkExist;
                }
              });
            }
          } else {
            this.custsOfMvBackIsLoading = false;
            return chkExist;
          }
        });
        this.custsOfMvBackIsLoading = false;
        return chkExist;
      }
      this.custsOfMvBackIsLoading = false;
      return chkExist;
    },
  },
  methods: {
    moment,
    ...mapActions([
      "updateUserItems",
      "updateAllHolderSearchData",
      "updateQueryKeyword",
    ]),
    checkKeyword() {
      this.keyword = this.cleanSpecialChar(this.keyword);
      if (this.stringBytes(this.keyword, false, 40) > 40) {
        this.keyword = this.keyword.substring(0, this.stringBytes(this.keyword, true, 40));
      }
    },
    async checkMvBack() {
      this.custsOfMvBackIsLoading = true;
      let chkExist = false;
      if (
        (!(this.CustInfo.ID && localStorage.CustID) &&
          !(localStorage.SerNo && this.CustInfo.serNo)) ||
        localStorage.checkMvBack == "false"
      ) {
        this.custsOfMvBackIsLoading = false;
        return chkExist;
      } else {
        await getFamilyMemberByCsidNo(
          this.$store.state.userInfo.id,
          this.CustInfo.ID || this.CustInfo.serNo
        ).then((result) => {
          if (result.header) {
            if (result.data && result.data.length > 0) {
              result.data.forEach((item) => {
                if (
                  item.csidno &&
                  item.familyid &&
                  item.csidno === item.familyid
                ) {
                  this.updateUserItems(item);
                  localStorage.userItems = JSON.stringify(item);
                  chkExist = true;
                  return chkExist;
                }
              });
            }
          } else {
            this.custsOfMvBackIsLoading = false;
            return chkExist;
          }
        });
        this.custsOfMvBackIsLoading = false;
        return chkExist;
      }
      this.custsOfMvBackIsLoading = false;
      return chkExist;
    },
    changeCoverMask(item){
      this.getAllHouseholderBySalesResult.forEach( otherItem => {
        if(otherItem != item){
            otherItem.namecovermask = false
        }
      });
    },
    saveUserItems(item, hasParam) {
      console.log("saveUserItems", item)
      this.updateUserItems(item);
      localStorage.userItems = JSON.stringify(item);
      if (hasParam) this.$router.push({ name: "relation", params: {item} });
      else this.$router.push({ name: "relation" });
    },

    cleanSearch() {
      this.keyword = "";
      this.isSearch = "D";
      this.init();
    },
    addFamilyName(familyNameList) {
      let str = "";
      familyNameList.forEach((familyItem, familyIndex) => {
        str +=
          familyIndex + 1 == familyNameList.length
            ? this.truncate(familyItem, 12)
            : this.truncate(familyItem, 12) + "、";
      });
      let result = this.truncate(str, 30);
      return result[result.length - 4] == "、" &&
        result[result.length - 1] == "."
        ? result.substring(0, result.length - 4) + "..."
        : result;
    },
    len(str) {
      return str.replace(/[^\x00-\xff]/g, "xx").length;
    },
    sub(str, n) {
      let l = 0;
      for (let i = 0; i < str.length; i++) {
        if (str[i].match(/[^\x00-\xff]/g)) {
          l += 2;
        } else {
          l++;
        }
        if (l >= n) {
          return str.substr(0, i + 1);
        }
      }
    },
    truncate(str, n) {
      if (str) {
        return this.len(str) > n ? this.sub(str, n) + "..." : str;
      } else {
        return "";
      }
    },
    doSearch() {
      if (this.keyword === "") {
        this.isSearch = "D";
        this.updateAllHolderSearchData([]);
        return;
      }
      this.isSearch = "S";
      this.getFamilyMemberByconditionResult = [];
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.custsOfAgntIsLoading = true;
      getFamilyMemberBycondition(
        this.$store.state.userInfo.id,
        this.keyword
      ).then((result) => {
        if (result.header && result.header.status == "200" && result.data) {
          this.getFamilyMemberByconditionResult = result.data;
          this.updateAllHolderSearchData(result.data);
        } else {
          this.getFamilyMemberByconditionResult = [];
          this.updateAllHolderSearchData([]);
        }

        this.remoteDataMessage = "查無歸戶資訊，請確認您輸入之資料是否正確";
        this.custsOfAgntIsLoading = false;
        this.registerHanlink(); // for 難字更新

        // this.custsOfAgntIsLoading = false;
      });
    },
    formatDate(preDate) {
      if (preDate) {
        let dd = moment(preDate).format("YYYY-MM-DD").split("-");
        dd[0] = dd[0] - 1911;
        dd = dd.join("/");

        return dd;
      } else {
        return "";
      }
    },
    warningSubmit() {
      // 確認，進入家戶
      localStorage.checkMvBack = true;
      this.panelClose("warningModalOpen");
      this.$router.push({ name: "relation" });
    },
    warningClose() {
      // 取消，進入列表
      localStorage.checkMvBack = false;
      this.panelClose("warningModalOpen");
    },
    init() {
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.custsOfAgntIsLoading = true;
      getAllHouseholderBySales(this.$store.state.userInfo.id).then((result) => {
        if (result.header && result.header.status == "200") {
          this.getAllHouseholderBySalesResult = result.data;
        } else {
          this.$toast.info({ title: result.header.message, timeOut: "10000" });
        }
        this.remoteDataMessage =
          "無任何家戶 \n (請先將客戶完成歸戶，才能開始使用保單健檢)";
        this.custsOfAgntIsLoading = false;
        this.registerHanlink(); // for 難字更新
      });
    },
    clearSearchKeyWord() {
      //進入我要歸戶時，清除共用的查詢關鍵字資料
      console.log("clearSearchKeyWord")
      this.updateQueryKeyword("");
    },
    checkFamily(url) {
      this.panelClose("toOldSystem");

      // 點擊建議書/保單健檢
      const checkRegex = /\/detail\//;
      const checkInsuranceRegex = /\/insurance-check/;
      const checkRecommandRegex = /\/recommand/;

      localStorage.fromMv = "Y";

      // if(url=='mv/allHolder'){
      //   this.updateAllHolderSearchData('')
      // }

      // 只有在客戶的「基本資料」頁面過來時才需做家戶判斷
      if (checkRegex.test(window.location.href)) {
        //  如果沒有設定客戶 ID 導到建議書首頁
        let store = this.$store.state.custInfo;
        if (
          (store.ID == "" || store.ID == undefined) &&
          (store.serNo == "" || store.serNo == undefined)
        ) {
          this.$router.push({ path: `/${url}` });
        } else {
          // 查詢家戶資料
          this.nextTargetUrl = url;
          this.panelOpen("RecommandModalOpen");
        }
      } else if (
        (checkInsuranceRegex.test(window.location.href) &&
          url === `recommand`) ||
        (checkRecommandRegex.test(window.location.href) &&
          url === `insurance-check`) ||
        (localStorage.checkMvBack == "true" &&
          this.checkUrlSysNo(window.location.href, "mv") &&
          (url === `recommand` || url === `insurance-check`))
      ) {
        // 從「保單健檢」點擊「建議書」或「建議書」點擊「保單健檢」時需跳出確認
        this.$router.push({ name: url, params: { checkCust: true } });
      } else {
        this.$router.push({ path: `/${url}` });
      }
    },
  },
  mounted() {
    this.init();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
      if (
        vm.$store.state.allHolderSearchData &&
        vm.$store.state.allHolderSearchData.length > 0 &&
        vm.prevRoute.name === "relation"
      ) {
        vm.getFamilyMemberByconditionResult =
          vm.$store.state.allHolderSearchData;
        vm.isSearch = "S";
      }

      // vuex/localStorage內有ID
      if (
        (vm.CustInfo.ID && localStorage.CustID) ||
        (localStorage.SerNo && vm.CustInfo.serNo)
      ) {
        // 來源為CRM客戶資訊頁面
        if (vm.prevRoute.path.includes("detail")) {
          //導頁從COMPUTED改至beforeRouteEnter
          localStorage.checkMvBack = true;
          vm.checkMvBack().then((result) => {
            if (result) {
              vm.$router.push({ name: "relation" });
            }
          });
          return;
        } else if (
          vm.prevRoute.name == "insurance-check" ||
          vm.prevRoute.name == "recommand" || 
          vm.prevRoute.fullPath.indexOf("/mf/") > -1
        ) {
          // 來源為建議書或保單健檢，跳出提示訊息
          vm.checkMvBack().then((result) => {
            let familyLeader = JSON.parse(localStorage.userItems);
            if (familyLeader) {
              vm.currentWarningType = "confirmOK";
              vm.warningData.confirmOK.message = `請問您是否要繼續使用「${familyLeader.name}」的家戶?`;
              vm.panelOpen("warningModalOpen");
            }
          });
        }
      }

      localStorage.checkMvBack = false;
    });
  },
  destroyed() {
    console.log("destroyed (UserItems)")
  }
};
</script>
<style lang="scss" scoped>
.card {
  flex: 1;
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 10px 20px;
  border: 1px solid #989ca2;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;

  .desc {
    vertical-align: middle;
    margin-right: 10px;
  }
}
/* #Search::-webkit-search-cancel-button{
    -webkit-appearance: none;
    height: 20px;
    width: 20px;
    border-radius:10px;
    background: rgb(226, 175, 175);
} */
.pre-formatted {
  white-space: pre;
}

#searchclear {
  position: absolute;
  right: 40px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}

// input[type="search"]::-webkit-search-cancel-button {
//   -webkit-appearance: none;
// }

.cardList {
  padding: 10px 20px 10px 20px;
  margin-right: 13px;
  margin-bottom: 20px;
  margin-left: 0px;
}

.cardSearch {
  margin-right: 17px;
}

.font-24 {
  font-size: 24px;
}
.font-16 {
  font-size: 16px;
}

.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
}

.ml-44 {
  margin-left: 44px;
}
.ml-45 {
  margin-left: 45px;
}

.mb-20 {
  margin-bottom: 20px;
}
.h2w3 {
  height: 20px;
  width: 30px;
}
.cardCon {
  border-radius: 8px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);
  border: solid 1px #989ca2;
  background-color: #ffffff;
}
.w-120 {
  width: 120px;
}
.w-181 {
  width: 181px;
}
.h-44 {
  height: 44px;
}
.fw-600 {
  font-weight: 600;
}
</style>
